<script setup>
import { onMounted, ref, watchEffect } from 'vue'
import { useDomainStore } from '@stores/domain'
import { http } from '@modules/useHttp'
import { MediaItem } from '@components/marketing/media'

const props = defineProps({
  slwId: {
    type: Number,
    required: true,
  },
  address: {
    type: String,
    required: true,
  },
})

const domainStore = useDomainStore()

const thumbnail = ref('')
const downloadName = ref('')
const downloadUrl = ref('')

const fetchQrCode = async () => {
  thumbnail.value = ''
  downloadName.value = ''
  downloadUrl.value = ''

  const response = await http().get(`/ui/marketing/slw/${props.slwId}/media/QR_CODE`, {
    params: {
      address: props.address,
      width: 120,
      height: 120,
    },
  })

  thumbnail.value = response.data.thumbnail
  downloadName.value = response.data.downloadName
  downloadUrl.value = response.data.downloadUrl
}

onMounted(() => fetchQrCode())
watchEffect(() => domainStore.isReserved && fetchQrCode())

const items = [
  { name: 'Property Website', value: 1 },
]
</script>

<template>
  <MediaItem
    title="QR Code"
    :item="1"
    :items="items"
    :thumbnail="thumbnail"
    :thumbnail-mobile="{ width: '90px', height: '90px' }"
    :thumbnail-desktop="{ width: '120px', height: '120px' }"
    impression-category="slw"
    impression-type="qr"
    :impression-id="slwId"
    :download-file-name="downloadName"
    :download-file-url="downloadUrl"
    :is-new="false"
  />
</template>
